// Icons must be registered before components
import "./icons.js";

// Web Awesome components
import "@awesome.me/webawesome-pro/dist/components/page/page.js";
import "@awesome.me/webawesome-pro/dist/components/avatar/avatar.js";
import "@awesome.me/webawesome-pro/dist/components/icon/icon.js";
import "@awesome.me/webawesome-pro/dist/components/button/button.js";
import "@awesome.me/webawesome-pro/dist/components/divider/divider.js";
import "@awesome.me/webawesome-pro/dist/components/card/card.js";
import "@awesome.me/webawesome-pro/dist/components/badge/badge.js";
import "@awesome.me/webawesome-pro/dist/components/format-date/format-date.js";
import "@awesome.me/webawesome-pro/dist/components/callout/callout.js";
import "@awesome.me/webawesome-pro/dist/components/tooltip/tooltip.js";
import "@awesome.me/webawesome-pro/dist/components/copy-button/copy-button.js";

import "$styles/index.css";
import "$styles/syntax-highlighting.css";

// Mastodon comments web component
import "./vendor/mastodon-comments.js";

// Import all JavaScript & CSS files from src/_components
import _components from "$components/**/*.{js,jsx,js.rb,css}";

import "./controllers";

import Prism from "prismjs";
import "prismjs/components/prism-ruby";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-json";
import "prismjs/components/prism-yaml";

// Line highlight plugin
import "prismjs/plugins/line-highlight/prism-line-highlight";
import "prismjs/plugins/line-highlight/prism-line-highlight.css";

// Line numbers plugin
import "prismjs/plugins/line-numbers/prism-line-numbers";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";

// Move data-line from wrapper div to pre (Kramdown puts IAL attributes on wrapper)
function fixDataLineAttributes() {
	document
		.querySelectorAll("div[data-line] > .highlight > pre")
		.forEach((pre) => {
			const wrapper = pre.closest("div[data-line]");
			if (wrapper) {
				pre.setAttribute("data-line", wrapper.getAttribute("data-line"));
			}
		});
}

// Highlight code blocks
document.addEventListener("DOMContentLoaded", () => {
	fixDataLineAttributes();
	Prism.highlightAll();
});
